import { z } from 'zod';

// Login form validation (both client and team portals)
export const loginSchema = z.object({
  username: z.string().min(1, 'Username is required').max(255, 'Username too long'),
  password: z.string().min(1, 'Password is required').max(128, 'Password too long'),
});
export type LoginFormData = z.infer<typeof loginSchema>;

// create-admin-user edge function input validation
export const createAdminUserSchema = z.object({
  email: z.string().email('Valid email is required').max(255),
  password: z.string().min(8, 'Password must be at least 8 characters').max(128),
  full_name: z.string().min(1, 'Name is required').max(255).optional(),
  role: z.enum(['super_admin', 'team_admin', 'member']).default('member'),
});
export type CreateAdminUserInput = z.infer<typeof createAdminUserSchema>;

// AddClientModal fields that create a Supabase auth user
export const addClientSchema = z.object({
  companyName: z.string().min(1, 'Company name is required').max(255),
  contactName: z.string().min(1, 'Contact name is required').max(255),
  email: z.string().email('Valid email is required').max(255),
  phone: z.string().max(20).optional(),
  package: z.enum(['standard', 'elite', 'test']),
});
export type AddClientInput = z.infer<typeof addClientSchema>;
